import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: '_.early_repayment.confirm_repayment.title',
        defaultMessage: 'Confirm repayment'
    },
    summaryTitle: {
        id: '_.early_repayment.confirm_repayment.summary_title',
        defaultMessage: `You're repaying`
    },
    summaryBreakdown: {
        id: '_.early_repayment.confirm_repayment.summary_breakdown',
        defaultMessage:
            'This will reduce your outstanding balance to {newBalance}.'
    },
    paidBy: {
        id: '_.early_repayment.confirm_repayment.paid_by',
        defaultMessage: 'Select a preferred payment method'
    },
    back: {
        id: '_.early_repayment.confirm_repayment.back',
        defaultMessage: '← Previous step'
    },
    next: {
        id: '_.early_repayment.confirm_repayment.next',
        defaultMessage: 'Make repayment'
    },
    showSchedule: {
        id: '_.early_repayment.confirm_repayment.show_schedule',
        defaultMessage: 'See your new schedule in full'
    },
    showManualRepaymentDetailsQuestion: {
        id: '_.early_repayment.confirm_repayment.show_manual_repayment_details_question',
        defaultMessage: 'Want to manually repay? {link}.'
    },
    showManualRepaymentDetailsLink: {
        id: '_.early_repayment.confirm_repayment.show_manual_repayment_details_link',
        defaultMessage: 'Click here to see our bank details'
    },
    tideNote: {
        id: '_.early_repayment.confirm_repayment.tide_note',
        defaultMessage:
            'Note: Tide bank accounts are not compatible with Instant Bank Transfer - please select a card from the dropdown instead.'
    }
});
